
import { useEffect, useState } from "react";
import NewsSlider from "../newsslider/newsslider";
import './home.css';
import { useTranslation } from 'react-i18next';
import api from '../../api/axios';

const Home = () => {
    const { t } = useTranslation();
    const [pictureSrc, setPictureSrc] = useState("");
    const [isMobile, setIsMobile] = useState(typeof window !== "undefined" ? window.innerWidth <= 768 : false);
    const [showFullText, setShowFullText] = useState(false);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const fetchPicture = async () => {
            try {
                const pictureId = 22; // 🔹 hardcoded for now, can vary per site later
                const response = await api.get(`/user/getwebsitepicture/${pictureId}`);
                setPictureSrc(response.data.picture); // base64 string
            } catch (err) {
                console.error("Error fetching picture:", err);
            }
        };

        fetchPicture();
    }, []);

    const getShortText = (text) => {
        const sentences = text.split('. ');
        if (sentences.length < 2) return text;
        const secondSentenceWord = sentences[1].trim().split(' ')[0];
        return sentences[0] + ". " + secondSentenceWord;
    };

    return (
        <div className="home-wrapper" id="home">
            <div className="home-bg" style={{
                backgroundImage: pictureSrc ? `url(${pictureSrc})` : "none",
            }}></div>
            <div className="home-content">
                <div className="home-text">
                    <h1>{t('BarMatch')}</h1>
                    <p>
                        {(!isMobile || showFullText) ? t('BarMatchText') : getShortText(t('BarMatchText'))}
                        {isMobile && !showFullText && (
                            <span className="read-more-btn" onClick={() => setShowFullText(true)}> ...mehr</span>
                        )}
                    </p>
                    <div className="home-input">
                        <button type="button" onClick={() => {
                            const targetId = window.innerWidth <= 850 ? 'next-dates' : 'dates';
                            document.getElementById(targetId)?.scrollIntoView({ behavior: 'smooth' });
                        }}>
                            {t('Events')}
                        </button>
                    </div>
                </div>
                <div className="home-slider">
                    <NewsSlider />
                </div>
            </div>
        </div>
    )
}

export default Home;